actions:
  about: 정보
  background: 배경
  drag-position: 위치 드래그
  hearing: 음성 인식
  outfits: 코디
  view: 시점
  wardrobe: 옷장
background:
  title: 배경
  loading: 불러오는 중...
  empty: 사용할 수 있는 배경이 없습니다
  transparent: 투명
  blur: 흐림
  video: 동영상
  upload-image: 이미지 업로드
  upload-video: 동영상 업로드
  custom-image: 사용자 지정 이미지
  custom-video: 사용자 지정 동영상
chat:
  actions:
    retry: Retry
  message:
    character-name:
      airi: MoeMoe
      core-system: 코어
      you: 당신
  reasoning: 추론
  sessions:
    title: 대화
    new: + 새로 만들기
    empty: 아직 대화가 없습니다
    cloud-badge: 클라우드에 동기화됨
    new-chat-fallback: 새 채팅
    delete: 대화 삭제
message: 듣고 있어요...
send-mode:
  title: 전송 키
  enter: 엔터
  ctrl-enter: Ctrl + Enter
  double-enter: 엔터 두 번
operations:
  load-models: 모델 불러오기
  load-models-status:
    loading: 로딩 중
    ready: 준비됨
select-a-audio-input: 오디오 입력 선택
select-a-model: 모델 선택
select-a-voice: 음성 선택
viewers:
  debug-menu:
    emotions: 감정
    emotions-btn:
      angry: 화남
      awkward: 어색함
      happy: 행복함
      neutral: '🙂 중립'
      question: '🤔 질문'
      sad: 슬픔
      surprised: 놀람
      think: '🤨 생각'
    vrm:
      camera: 카메라
      model:
        title: 모델
character-card:
  button: 캐릭터
  title: 캐릭터 선택
  subtitle: 대화할 캐릭터를 선택하세요
  empty: 캐릭터가 없습니다
  loading: 캐릭터를 불러오는 중...
  load-more: 더 불러오기
  no-more: 전부 불러왔습니다
  pull-to-load-more: 위로 당겨 더 불러오기
  release-to-load: 놓으면 더 불러옵니다
  loading-more: 불러오는 중...
  apply: 적용
  applied: 적용 중
  local-section: 내 프로필
  remote-section: 사용 가능한 캐릭터
download-app:
  button: 앱 다운로드
  aria: Android 앱 다운로드
language-switcher:
  button: 언어
  title: 언어 선택
membership:
  title: 멤버십
  upgrade: 프리미엄으로 업그레이드
profile-switcher:
  no-profile: 프로필 없음
  no-profiles: 아직 프로필 없음
  save-as-new: 새로운 프로필로 저장하기
  new-profile-name: 프로필 이름
  manage: 프로필 관리
promo-banner:
  items:
    signin:
      watermark: 달
      fallbackLabel: 달의 선물
      title: 7일 출석
      eventName: 출석하여 별먼지와 아바타 프레임, 출시 선물을 받으세요.
      date: 03/28 - 04/10
      reward: 최대 별먼지 120
      cta: 로그인
    build:
      watermark: 빌드
      fallbackLabel: 빌드 보너스
      title: 보급 상자 보너스
      eventName: 건설 작업을 완료해 보너스 교환권과 2배 자재를 받으세요.
      date: 03/30 - 04/12
      reward: 보급권 5장 + 업그레이드 자재
      cta: 작업 보기
    spring:
      watermark: 봄
      fallbackLabel: 봄 뽑기
      title: 캡슐 카니발
      eventName: 봄 뽑기에 참여해 버블과 참, 테마 가구를 해금하세요.
      date: 04/01 - 04/18
      reward: 첫 뽑기 반값 + 레어 참
      cta: 지금 뽑기
    coupon:
      watermark: 대화
      fallbackLabel: 쿠폰
      title: 충전 쿠폰
      eventName: 채팅 상호작용을 완료하고 확장팩과 보이스팩 쿠폰을 받으세요.
      date: 04/02 - 04/20
      reward: 30 결제 시 6 할인 / 68 결제 시 15 할인
      cta: 쿠폰 받기
    home:
      watermark: 홈
      fallbackLabel: 방 테마
      title: 봄 테마 업데이트
      eventName: 창문, 책상, 무드등 테마를 해금해 방을 새롭게 꾸며보세요.
      date: 04/05 - 04/22
      reward: 출석 시 테마 뽑기 티켓 증정
      cta: 테마 보기
waiting: 대기 중
websocket-status:
  connected: 연결됨
  disconnected: 연결 없음
  open-settings: 연결 설정 열기
